import { Button, ButtonProps, IconButton, IconButtonProps } from '@mui/material';
import { useRef } from 'react';

interface FileInputProps extends ButtonProps {
  onFilePicked: (file: File | null | undefined) => void;
  accept?: string;
}

export const FileInputButton = (props: FileInputProps) => {
  const fileInput = useRef<HTMLInputElement>(null);
  return (
    <>
      <Button {...props} onClick={() => fileInput?.current?.click()}>
        {props.children}
      </Button>

      <input
        onChange={(e) => {
          props.onFilePicked(fileInput.current?.files?.item(0));
        }}
        accept={props.accept}
        ref={fileInput}
        type="file"
        style={{ display: 'none' }}
      />
    </>
  );
};
